import { Flex, Typography, theme } from "antd"
import React, { type ReactNode } from "react"
import { useTranslation } from "react-i18next"

const { Title, Text } = Typography

interface StoryStepShellProps {
  eyebrowKey: string
  titleKey: string
  subtitleKey: string
  calloutKey?: string
  children: ReactNode
}

/** One consistent layout for all three concept steps of the product story:
 * a short eyebrow + headline + supporting line, the step's own visual, then
 * an optional bold callout underneath it. */
export const StoryStepShell = ({
  eyebrowKey,
  titleKey,
  subtitleKey,
  calloutKey,
  children
}: StoryStepShellProps) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <Flex vertical gap={28} align="center" className="text-center">
      <Flex vertical gap={6} align="center" className="max-w-2xl">
        <Text
          className="text-xs font-semibold uppercase tracking-widest"
          style={{ color: token.colorPrimary }}
        >
          {t(eyebrowKey)}
        </Text>
        <Title level={2} className="!mb-0">
          {t(titleKey)}
        </Title>
        <Text type="secondary" className="text-base">
          {t(subtitleKey)}
        </Text>
      </Flex>

      <div className="w-full text-left">{children}</div>

      {calloutKey && (
        <Text strong className="text-lg" style={{ color: token.colorPrimary }}>
          {t(calloutKey)}
        </Text>
      )}
    </Flex>
  )
}
